import { Button, HorizontalDivider, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SkeletonLoaders } from '@hero/components';
import { constants } from '@hero/configs';
import { PRODUCT_LIST_PAGINATION_LIMIT } from '@hero/constants';
import { useInViewObserver } from '@hero/hooks';
import { useSearchProducts } from '@hero/services/product-service/hooks';

import { CategorySwiper } from './CategorySwiper';
import * as S from './style';

export function Category({ title, onSeeAll, data }) {
  const { t } = useTranslation();
  const categoryRef = useRef(null);
  const [isReady, setIsReady] = useState(false);

  const entityFilter = useMemo(() => {
    if (data?.entity_type?.toLowerCase() === 'collection') {
      return {
        collectionIds: [data.entity_id]
      };
    }
    return {
      categoryIds: [data?.entity_id]
    };
  }, [data]);

  const { data: productsData, isSuccess: productsIsSuccess } = useSearchProducts({
    params: {
      filters: entityFilter
    },
    options: {
      enabled: (!!entityFilter?.collectionIds || !!entityFilter.categoryIds) && isReady
    }
  });

  useInViewObserver(categoryRef, (/*entry*/) => {
    // Perform any action with the entry.target when it comes into viewport
    // productsRefetch();
    setIsReady(true);
  });

  const hasProducts = !!productsData?.docs?.length;

  return (
    <S.Category ref={categoryRef}>
      <S.CategoryHeader>
        <Typography variant="subtitle3Bold" as="h2">
          {title}
        </Typography>
        <HorizontalDivider $margin="0 24px" $height="1px" />
        {onSeeAll && (
          <Button size="sm" onClick={onSeeAll}>
            {t('seeAll')}
          </Button>
        )}
      </S.CategoryHeader>
      {productsIsSuccess && hasProducts ? (
        <CategorySwiper key={title} data={productsData?.docs} />
      ) : productsIsSuccess && !hasProducts ? (
        <S.CategoryContentEmpty>{t('noItemsFoundForCategory')}</S.CategoryContentEmpty>
      ) : (
        <S.CategoryItems>
          <SkeletonLoaders.ProductLoader
            width={constants.products?.card?.width}
            count={PRODUCT_LIST_PAGINATION_LIMIT}
          />
        </S.CategoryItems>
      )}
    </S.Category>
  );
}

Category.propTypes = {
  title: PropTypes.string.isRequired,
  onSeeAll: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired
};
